import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB-QMbgm8LKrLybbnj_dolDE0tmiVJesVQ",
  authDomain: "pewala-app.firebaseapp.com",
  projectId: "pewala-app",
  storageBucket: "pewala-app.firebasestorage.app",
  messagingSenderId: "190999031833",
  appId: "1:190999031833:web:53b2409bde456d55d7fa88",
  measurementId: "G-J1TR9ZTP38"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and Export Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const analytics = getAnalytics(app); // Optional: if you want to use analytics